(function() {
    'use strict';
    /**
     * @memberof app
     *@ngdoc service
     *@name modalService
     *@description
     *Servicio de Modal
     */

    angular
        .module('app')
        .factory('modalService', modalService);

    modalService.$inject = [];

    function modalService() {    

    	var modals = {
    		title:"",
    		visible: false,
    		msg:"",
    		closeCallback:function(){return true;}
    	};

    	modals.show = function(title,msg,callback)
    	{
    		modals.title = title;
    		modals.msg = msg;
    		modals.visible = true;
    		if (typeof callback === "function") {
    			modals.closeCallback = callback;
			}else
			{
				modals.closeCallback = function(){return true;};
			}
    	}

    	modals.close = function()
    	{
    		modals.title = "";
    		modals.msg = "";
    		modals.visible =false;
    		modals.closeCallback();
    	}


    	return modals;
    }



})();
